<div class="content-area">
  <div class="clr-row" id="first-row">
    <div class="clr-col-10 clr-col-md-5 clr-offset-1 clr-offset-md-1 mb-3 justify-content-center d-flex flex-column">
      <h1>{{textData.general.title}}</h1>
      <div class="p-2 rounded-background">
        <p>{{textData.general.description1}}</p>
        <p>{{textData.general.description2}}</p>
      </div>
      <a [routerLink]="['/activities']">
        <button class="orange-button mt-4">{{textData.general.button}}</button>
      </a>
    </div>
    <div class="clr-col-10 clr-col-md-5 clr-offset-1 clr-offset-md-0 py-2 mb-3 align-items-center d-flex justify-content-end" id="first-image">
      <img src="assets/family.png" class="rectangular-image" alt="Jocuri biblice și activități creștine pentru copii"/>
    </div>
  </div>
  <div class="clr-row" id="second-row">
    <div
        class="clr-col-12 clr-col-md-10 clr-col-lg-9 clr-col-xl-7 clr-offset-md-1 mb-3 position-relative justify-content-center justify-content-md-start d-flex">
      <a [routerLink]="['/activities']">
      <div class="text-box pb-4 pr-4 justify-content-around d-md-flex flex-column d-none">
        <h2 class="activities-title">{{textData.activities.title}}</h2>
        <div class="call-to-action">{{textData.activities.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      <div class="circle-image-wrapper position-relative">
        <img src="assets/activities.png" class="circle-image" alt="Jocuri biblice și activități online și offline pentru copii"/>
      </div>
      </a>
    </div>
    <div class="clr-col-10 clr-offset-1 d-md-none mb-4">
      <a [routerLink]="['/activities']" class="text-decoration-none">
      <div class="text-box-inline pb-5 pr-4 justify-content-around d-flex flex-column">
        <h2 class="activities-title">{{textData.activities.title}}</h2>
        <div class="call-to-action">{{textData.activities.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      </a>
    </div>
  </div>
  <div class="clr-row" id="third-row">
    <div
        class="clr-col-12 clr-col-md-10 clr-col-lg-9 clr-col-xl-7 clr-offset-md-2 clr-offset-lg-2 clr-offset-xl-5 mb-3 position-relative justify-content-center justify-content-md-start d-flex">
      <a [routerLink]="['/coloring']" class="text-decoration-none">
      <div class="text-box pb-4 pr-4 justify-content-around d-md-flex flex-column d-none">
        <h2 class="coloring-title">{{textData.coloring.title}}</h2>
        <div class="call-to-action">{{textData.coloring.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      <div class="circle-image-wrapper position-relative">
        <img src="assets/coloring.png" class="circle-image" alt="Planșe de colorat biblice pentru copii"/>
      </div>
      </a>
    </div>
    <div class="clr-col-10 clr-offset-1 d-md-none mb-4">
      <a [routerLink]="['/coloring']" class="text-decoration-none">
      <div class="text-box-inline pb-5 pr-4 justify-content-around d-flex flex-column">
        <h2 class="coloring-title">{{textData.coloring.title}}</h2>
        <div class="call-to-action">{{textData.coloring.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      </a>
    </div>
  </div>
  <div class="clr-row" id="fourth-row">
    <div
        class="clr-col-12 clr-col-md-10 clr-col-lg-9 clr-col-xl-7 clr-offset-md-1 mb-3 position-relative justify-content-center justify-content-md-start d-flex">
      <a [routerLink]="['/cartoons']" class="text-decoration-none">
      <div class="text-box pb-4 pr-4 justify-content-around d-md-flex flex-column d-none">
        <h2 class="cartoons-title">{{textData.cartoons.title}}</h2>
        <div class="call-to-action">{{textData.cartoons.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      <div class="circle-image-wrapper position-relative">
        <img src="assets/tv.jpg" class="circle-image" alt="Desene animate creștine pentru copii"/>
      </div>
      </a>
    </div>
    <div class="clr-col-10 clr-offset-1 d-md-none mb-4">
      <a [routerLink]="['/cartoons']" class="text-decoration-none">
      <div class="text-box-inline pb-5 pr-4 justify-content-around d-flex flex-column">
        <h2 class="cartoons-title">{{textData.cartoons.title}}</h2>
        <div class="call-to-action">{{textData.cartoons.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      </a>
    </div>
  </div>
  <div class="clr-row" id="fifth-row">
    <div
        class="clr-col-12 clr-col-md-10 clr-col-lg-9 clr-col-xl-7 clr-offset-md-2 clr-offset-lg-2 clr-offset-xl-5 mb-3 position-relative justify-content-center justify-content-md-start d-flex">
      <a [routerLink]="['/songs']" class="text-decoration-none">
      <div class="text-box pb-4 pr-4 justify-content-around d-md-flex flex-column d-none">
        <h2 class="songs-title">{{textData.songs.title}}</h2>
        <div class="call-to-action">{{textData.songs.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      <div class="circle-image-wrapper position-relative">
        <img src="assets/sing.png" class="circle-image" alt="Cântece creștine pentru copii"/>
      </div>
      </a>
    </div>
    <div class="clr-col-10 clr-offset-1 d-md-none mb-4">
      <a [routerLink]="['/songs']" class="text-decoration-none">
      <div class="text-box-inline pb-5 pr-4 justify-content-around d-flex flex-column">
        <h2 class="songs-title">{{textData.songs.title}}</h2>
        <div class="call-to-action">{{textData.songs.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      </a>
    </div>
  </div>
  <div class="clr-row" id="sixth-row">
    <div class="clr-col-12 clr-col-md-10 clr-col-lg-9 clr-col-xl-7 clr-offset-md-1 mb-3 position-relative justify-content-center justify-content-md-start d-flex">
      <a [routerLink]="['/reviews']" class="text-decoration-none">
      <div class="text-box pb-4 pr-4 justify-content-around d-md-flex flex-column d-none">
        <h2 class="reviews-title">{{textData.reviews.title}}</h2>
        <div class="call-to-action">{{textData.reviews.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      <div class="circle-image-wrapper position-relative">
        <img src="assets/reviews.png" class="circle-image" alt="Recenzii jocuri biblice și produse creștine pentru copii"/>
      </div>
      </a>
    </div>
    <div class="clr-col-10 clr-offset-1 d-md-none mb-4">
      <a [routerLink]="['/reviews']" class="text-decoration-none">
      <div class="text-box-inline pb-5 pr-4 justify-content-around d-flex flex-column">
        <h2 class="reviews-title">{{textData.reviews.title}}</h2>
        <div class="call-to-action">{{textData.reviews.button}}</div>
        <div class="play-button">
          <button class="orange-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
      </div>
      </a>
    </div>
  </div>
</div>
